import * as React from "react";
import {
  blogPostsReducer,
  initialBlogPostsState,
} from "../../reducers/blog/blogPostsReducer";
import {
  BlogPostsAction,
  BlogPostsActionType,
  BlogPostsState,
} from "../../types/blog/blogPostsTypes";
import { getBlogPosts } from "@nls-2022/nls-api";

export const useBlogDetails = (): [
  BlogPostsState,
  React.Dispatch<BlogPostsAction>
] => {
  const [state, dispatch] = React.useReducer(
    blogPostsReducer,
    initialBlogPostsState
  );
  React.useEffect(() => {
    async function fetchBlogPosts() {
      try {
        const response = await getBlogPosts();
        dispatch({
          type: BlogPostsActionType.BlogPostsFetchSuccess,
          payload: response.data,
        });
      } catch (error) {}
    }
    fetchBlogPosts();
  }, []);
  return [state, dispatch];
};

//export default useBlogDetails;
